// Einheitlicher Münz-Hinweis für alle Spielseiten (Start + einzelne Games):
// oben die gesammelten Münzen mit "einlösen"-Button (führt zu Schriftbot),
// darunter der Sammel-Hinweis "10 Münzen = 1 gratis Download".
import { Link } from "react-router-dom";
import CoinIcon from "./CoinIcon";
import { COINS_PER_PDF } from "./gamesFirebase";

export default function CoinCollectBanner({ coins = 0, showCollected = false }) {
  return (
    <>
      {showCollected && (
        <div className="mt-1 flex items-center gap-2 flex-wrap">
          <span className="inline-flex items-center gap-1.5 text-sm text-white/70">
            <CoinIcon size={14} />
            <span className="font-bold text-white">{coins}</span> Münzen gesammelt
          </span>
          {coins >= COINS_PER_PDF && (
            <Link
              to="/"
              className="px-3 py-1 rounded-full bg-emerald-500 hover:bg-emerald-400 text-white text-xs font-bold transition-colors"
            >
              einlösen
            </Link>
          )}
        </div>
      )}
      <p className="mt-1 inline-flex items-center gap-1.5 text-sm text-white/70">
        <CoinIcon size={14} /> Sammle Münzen: {COINS_PER_PDF} Münzen ={" "}
        <span className="font-bold text-white">1 gratis Download</span>
      </p>
    </>
  );
}
